"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentPreview = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var faFile_1 = require("@fortawesome/pro-light-svg-icons/faFile");
var faFilePdf_1 = require("@fortawesome/pro-light-svg-icons/faFilePdf");
var faFilePowerpoint_1 = require("@fortawesome/pro-light-svg-icons/faFilePowerpoint");
var faFileExcel_1 = require("@fortawesome/pro-light-svg-icons/faFileExcel");
var faFileWord_1 = require("@fortawesome/pro-light-svg-icons/faFileWord");
var faFileCsv_1 = require("@fortawesome/pro-light-svg-icons/faFileCsv");
var faFileImage_1 = require("@fortawesome/pro-light-svg-icons/faFileImage");
var Behavior_1 = require("../../Behavior");
var ItemTypes_1 = require("./ItemTypes");
var Sendable_1 = require("./Sendable");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var ATTACHMENT_STYLES = "flex flex-grow m-1 relative bg-gray-300 bg-opacity-25";
var PREVIEW_WRAPPER_STYLES = "flex box-border m-0 w-full p-2";
var ICON_STYLES = "box-border m-0";
var TEXT_CONTENT_STYLES = "box-border m-0 w-full pl-4 my-auto";
var Icon = function (_a) {
    var fileId = _a.fileId;
    var extension = fileId.split(".").reverse()[0];
    var icon = faFile_1.faFile;
    switch (extension) {
        case "pdf":
            icon = faFilePdf_1.faFilePdf;
            break;
        case "xls":
            icon = faFileExcel_1.faFileExcel;
            break;
        case "xlsx":
            icon = faFileExcel_1.faFileExcel;
            break;
        case "ppt":
            icon = faFilePowerpoint_1.faFilePowerpoint;
            break;
        case "doc":
            icon = faFileWord_1.faFileWord;
            break;
        case "docx":
            icon = faFileWord_1.faFileWord;
            break;
        case "csv":
            icon = faFileCsv_1.faFileCsv;
            break;
        case "jpg":
            icon = faFileImage_1.faFileImage;
            break;
        case "jpeg":
            icon = faFileImage_1.faFileImage;
            break;
        case "png":
            icon = faFileImage_1.faFileImage;
            break;
        case "gif":
            icon = faFileImage_1.faFileImage;
            break;
    }
    return (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon, size: "2x" }, void 0);
};
var AttachmentPreview = function (_a) {
    var id = _a.id, canDrop = _a.canDrop, preview = _a.preview, progress = _a.progress, onSort = _a.onSort, onFinishSort = _a.onFinishSort, onDelete = _a.onDelete, index = _a.index;
    return ((0, jsx_runtime_1.jsx)(Behavior_1.Sortable, __assign({ id: id, index: index, type: ItemTypes_1.ItemTypes.File, onSort: onSort, onFinishSort: onFinishSort, sortDirection: "vertical" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: ATTACHMENT_STYLES }, { children: (0, jsx_runtime_1.jsx)(Sendable_1.Sendable, __assign({ onDelete: onDelete, deletable: canDrop, progress: progress, preview: preview, listMode: true }, { children: preview ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: PREVIEW_WRAPPER_STYLES }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: ICON_STYLES }, { children: (0, jsx_runtime_1.jsx)(Icon, { fileId: preview.id }, void 0) }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({ className: TEXT_CONTENT_STYLES }, { children: (0, jsx_runtime_1.jsx)("p", { children: preview.name }, void 0) }), void 0)] }), void 0)) : null }), void 0) }), void 0) }), void 0));
};
exports.AttachmentPreview = AttachmentPreview;
